import { useFormContext } from "react-hook-form";

import Grid from "@mui/material/Grid";

import InputFormField from "components/input-form-field";
import SelectFormField from "components/select-form-field";
import { WARRANTY_FIELD_TYPES } from "constants/products";

import { AddMasterProductFormValues } from "../add-master-product-form.component";

export default function WarrantySpecificationForm() {
  const { control } = useFormContext<AddMasterProductFormValues>();
  return (
    <Grid
      container
      width="100%"
      sx={{ pb: 4 }}
      columnSpacing={2}
      rowSpacing={4}
    >
      <Grid item xs={6}>
        <InputFormField
          name="specification.warranty_months"
          label="Warranty Months"
          type="number"
          inputProps={{ min: 0 }}
          control={control}
          sx={{ ml: 0 }}
          required
        />
      </Grid>
      <Grid item xs={6}>
        <SelectFormField
          name="specification.warranty_field"
          label="Warranty Type"
          control={control}
          sx={{ ml: 0 }}
          options={WARRANTY_FIELD_TYPES.getOptions()}
          required
          dropDownZIndex={1502}
        />
      </Grid>
    </Grid>
  );
}
